import { render, staticRenderFns } from "./ClientSupervisionCourse.vue?vue&type=template&id=23ac266f&scoped=true&"
import script from "./ClientSupervisionCourse.vue?vue&type=script&lang=js&"
export * from "./ClientSupervisionCourse.vue?vue&type=script&lang=js&"
import style0 from "./ClientSupervisionCourse.vue?vue&type=style&index=0&id=23ac266f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ac266f",
  null
  
)

export default component.exports